// extracted by mini-css-extract-plugin
export var addToCartButton = "_oz-b";
export var arrowButtonContainer = "_oz-9";
export var arrowButtonIcon = "_oz-a";
export var carouselArrowButton = "_oz-6";
export var carouselElementContainer = "_oz-1";
export var galleryThumbnail = "_oz-d";
export var galleryThumbnailImage = "_oz-e";
export var left = "_oz-7";
export var productDisplayCarouselContainer = "_oz-0";
export var productTileContainer = "_oz-2";
export var productTileImage = "_oz-4";
export var productTileImageContainer = "_oz-3";
export var productTileTitle = "_oz-5";
export var right = "_oz-8";
export var sliderOverflow = "_oz-c";